import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'arraysIdsFilter'
})
export class ArraysIdsFilterPipe implements PipeTransform {

  transform(items: any[], args: number[]): any[] {
    if(!items) return [];
    if(!args) return items;
    return items.filter( it => {
      if (args.indexOf(it.id, 0) > -1) {
        return it;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/arrays-ids-filter.pipe.ts